import React from 'react';
import InsurancePurchase from 'billing/purchases/InsurancePurchase';

const InsurancePurchaseScreen = ({ contractId, purchaseId }) => {
  return (
    <div className="">
      <h1>
        Complete Payment
      </h1>
      <InsurancePurchase contractId={contractId} purchaseId={purchaseId} />
    </div>
  );
}

export default InsurancePurchaseScreen;
